import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import TooltipButton from '../controls/TooltipButton'
import PlusDoorIcon from '../svgicons/PlusDoorIcon'
import UnitGrantDoorAccessDialog from './UnitGrantDoorAccessDialog'

class AddAccessToUnitButton extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    unit: PropTypes.object.isRequired,
  }

  static styles = () => ({
    buttonRoot: {
      borderRadius: 25,
      minHeight: 40,
      '& svg': {
        marginRight: 5,
      },
    },
  })

  state = {
    openDialog: false,
  }

  handleClick = () => {
    this.setState({ openDialog: true })
  }

  handleDialogClose = () => {
    this.setState({ openDialog: false })
  }

  render() {
    return (
      <>
        <TooltipButton
          classes={{ root: this.props.classes.buttonRoot }}
          onClick={this.handleClick}
          variant="outlined"
        >
          <PlusDoorIcon />
          Add Access
        </TooltipButton>

        <UnitGrantDoorAccessDialog
          unit={this.props.unit}
          open={this.state.openDialog}
          onClose={this.handleDialogClose}
        />
      </>
    )
  }
}

export default withStyles(AddAccessToUnitButton.styles)(AddAccessToUnitButton)
